module.exports = __webpack_public_path__ + "static/media/trial-score.a4f86367.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/trial-score.jpg
// module id = 55
// module chunks = 0